import { render, staticRenderFns } from "./ScoreExport.vue?vue&type=template&id=98589592&"
import script from "./ScoreExport.vue?vue&type=script&lang=js&"
export * from "./ScoreExport.vue?vue&type=script&lang=js&"
import style0 from "./ScoreExport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports